<template>
  <div>
    <v-row>
      <v-col cols="12" md="12" sm="12">
        <!-- Filter -->
        <v-card tile class="d-print-none mb-4">
          <v-container class="py-0 px-1">
            <v-form ref="form">
              <div class="d-flex overline justify-start align-center px-3">
                <v-icon class="grey--text" x-small>mdi-filter</v-icon>
                <div class="pl-2 grey--text" style="font-size: 10px">
                  {{ $t("filters") }}
                </div>
                <v-divider class="ml-4"></v-divider>
              </div>
              <v-row class="d-print-none px-2" no-gutters> </v-row>
            </v-form>
            <!-- sports -->
            <v-btn-toggle class="hidden-xs-only" v-model="toggle">
              <v-row no-gutters class="mx-2">
                <v-col
                  v-for="(sport, index) in sports"
                  :key="index"
                  :cols="$vuetify.breakpoint.smAndDown ? '4' : '3'"
                >
                  <v-btn
                    large
                    @click="getDataSport(sport.id_sport)"
                    style="flex: 1; width: 98%; margin: 0.1rem;"
                    v-model="sport.selected"
                  >
                    <v-icon left size="16">{{ iconT(sport.id_sport) }}</v-icon>
                    {{ sport.name_sport }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-btn-toggle>
            <!-- Filtro por pais -->
            <v-row no-gutters>
              <!-- <v-col cols="6" md="9"></v-col> -->
              <v-col cols="12" md="12" sm="12">
                <v-autocomplete
                  v-model="country"
                  :items="items"
                  :label="$t('filterByCountry')"
                  item-text="name"
                  item-value="id"
                  dense
                  filled
                  hide-details
                  solo-inverted
                  clearable
                  @change="filterByCountry"
                  :class="$vuetify.breakpoint.smAndDown ? 'pt-2' : 'pt-5 pb-3'"
                >
                  <template v-slot:item="data">
                    <img
                      width="15"
                      class="mr-4"
                      :src="
                        `https://sga-assets.s3-sa-east-1.amazonaws.com/flags/1x1/${data.item.flag}.svg`
                      "
                    />
                    {{ data.item.name }}
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <!-- end Filtro por pais -->

            <v-row v-if="!$vuetify.breakpoint.smAndUp">
              <v-col>
                <v-autocomplete
                  v-model="sport"
                  :items="listSports"
                  :label="$t('selectASport')"
                  item-text="name_sport"
                  item-value="id_sport"
                  @change="getDataSport(sport)"
                  dense
                  filled
                  hide-details
                  solo-inverted
                  clearable
                  class="hidden-sm-and-up"
                >
                  <template v-slot:item="data">
                    <v-icon left size="16">{{
                      iconT(data.item.id_sport)
                    }}</v-icon>
                    {{ data.item.name_sport }}
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <!-- end sports -->
          </v-container>
        </v-card>
      </v-col>
    </v-row>

    <v-alert
      outlined
      type="warning"
      border="left"
      class="mt-6"
      v-show="items.length == 0 && loading === false"
    >
      {{ $t("noDataFount") }}
    </v-alert>

    <v-row class="d-flex justify-center">
      <v-progress-circular v-show="loading" color="primary" indeterminate />
    </v-row>

    <!-- cards -->
    <v-row>
      <v-col cols="12" md="12" sm="12">
        <v-card class="mb-3" v-for="(item, index) in items" :key="index">
          <v-toolbar dense elevation="0">
            <v-toolbar-title class="subtitle-1">
              <img
                width="15"
                class="mt-1 mr-1"
                :src="
                  `https://sga-assets.s3-sa-east-1.amazonaws.com/flags/1x1/${item.flag}.svg`
                "
                :alt="item.flag"
                :title="item.name"
              />
              {{ item.name }}
              <v-spacer></v-spacer>
            </v-toolbar-title>
          </v-toolbar>
          <v-row>
            <v-col
              :style="
                $vuetify.breakpoint.smAndDown
                  ? 'display: flex; flex-direction: column;'
                  : 'display: inline-block;'
              "
              class="py-0 pr-0 pr-0  ml-3 mt-2 "
              v-for="(t, index) in item.tournaments"
              :key="`tounament-${index}}`"
              md="4"
              :cols="$vuetify.breakpoint.smAndDown ? '12' : '2'"
              :class="$vuetify.breakpoint.smAndDown ? 'ml-5' : ''"
            >
              <div>
                <strong>{{ t.name }}</strong>
                <v-icon
                  v-if="
                    t.tournament_highlighted &&
                      $store.state.operator.credit == 2
                  "
                  small
                  color="yellow"
                  class="mb-2 ml-2"
                  >mdi-star</v-icon
                >
              </div>
              <v-row class="px-2 pt-0 mb-2 align-center">
                <!-- Ativar ou desativar Liga -->

                <v-checkbox
                  class="ml-1"
                  :label="$t('active')"
                  v-model="t.selected"
                  :disabled="!canEditTournaments"
                  @change="
                    insertTournamentOperator({
                      ...t,
                      ...{ id_category: item.id },
                    })
                  "
                ></v-checkbox>
                <!-- Ativar ou inativa cash out no credit 2 -->
                <v-checkbox
                  :disabled="!canEditTournaments || !t.selected"
                  v-if="
                    t.tournament_highlighted &&
                    $store.state.operator.credit == 2
                      ? true
                      : false
                  "
                  class="ml-3"
                  label="Cash Out"
                  v-model="t.can_cash_out"
                  @change="
                    insertTournamentOperator({
                      ...t,
                      ...{ id_category: item.id },
                    })
                  "
                ></v-checkbox>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <!-- end cards -->
  </div>
</template>

<script>
import { icon } from "@/components/icon-sport/icon.js";
export default {
  data: () => ({
    original: [],
    items: [],
    listSports: [],
    sport: "",
    country: "",
    toggle: 0,
    loading: false,
  }),

  computed: {
    canEditTournaments() {
      return this.$permission("42");
    },
    sports() {
      return this.$store.state.sports;
    },
  },

  mounted() {
    this.toggle = 0;
    this.getDataSport(6046);
  },

  methods: {
    async getDataSport(id_sport) {
      this.loading = true;

      const request = await this.$request
        .post("/colab/settings/manageTournaments", { id_sport })
        .finally(() => {
          this.loading = false;
        });

      this.items = request.dados !== undefined ? request.dados.categories : [];

      this.original =
        request.dados !== undefined ? request.dados.categories : [];
      this.items.sort((a, b) => {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      });

      this.country = "";
      this.listSports = this.sports;
      if (this.country) this.filterByCountry();
    },

    filterByCountry() {
      this.items =
        this.country != undefined
          ? this.items.filter((item) => item.id == this.country)
          : this.original;
    },

    async insertTournamentOperator(item) {
      let obj = {
        id_category: item.id_category,
        selected: item.selected ? 1 : 0,
        id_tournament: item.id,
      };

      // Adiciona a possilidade de enviar cash out
      if (this.$store.state.operator.credit == 2) {
        obj.can_cash_out = item.can_cash_out && item.selected ? 1 : 0;
      } else {
        obj.can_cash_out = "";
      }

      await this.$request
        .post("/colab/settings/insertTournamentOperator", obj)
        .then((response) => {
          this.$store.commit("setFeedbackSnack", {
            msg: response.messages,
            color: response.dados.clear ? "success" : "error",
          });
        });
    },

    iconT: (id) => icon(id),
  },
};
</script>
